import React, { useContext, useEffect, useRef, useState } from "react";
import ALoader from "views/pages/manage/common/a-loader";
import { endpoint } from "views/pages/manage/common/constant";
import styles from './styles.module.scss';
import { ReactComponent as BackIcon } from 'assets/img/svg/BackButton.svg';
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { useHistory } from "react-router";
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import ListComponent from "./ListComponent";
import { deleteConfig, getCreateReqBody, getDropdowns } from "./constant";
import { RolePermissions } from "appContext";
import { PermissionContext } from "appContext";
import { pages } from "views/pages/manage/common/constant";
import Filters from "./Filters";
import { EMPTY_FILTER_FORM } from './constant'
import { updateRequest, getDropdownLabelsFromSelectArray, checkPermission, fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getAppliedFilterCount } from 'modules/studentTransfer/components/searchStudent/studentTransfersListing/utils.js';


const SecurityDepositSequencing = ({
    isBranchLevelConfig = false,
    dropdownData,
    dropdownDataLoading,
    defaultRow,
    setDefaultRow,
}) => {
    const [loader, setLoader] = useState(false)
    // const [dropdownData, setDropdownData] = useState();
    const [rows, setRows] = useState()
    const [isNew, setIsNew] = useState(false)
    const history = useHistory();
    const listRef = useRef();
    const [filterForm, setFilterForm] = useState({ ...EMPTY_FILTER_FORM });
    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 0,
        totalPage: 0,
        totalRecords: 0,
    });
    const [currPageSize, setCurrentPageSize] = useState(10);
    const userPermissions = RolePermissions(useContext(PermissionContext), pages['paymentCollectionMasterSdSequencing']['id']);

    const fetchList = async (reqObj = {}, pageNumber = 0, pageSize = currPageSize, isFilterApplied) => {
        setLoader(true);
        try {
            if (!isFilterApplied) {
                reqObj = {
                    ...reqObj,
                    businessAreas: isBranchLevelConfig
                        ? dropdownData?.activeBusinessAreas?.map(bu => bu?.label)
                        : ['ALL']
                }
            }
            const res = await fetchAllPostPromisedData(`${endpoint?.sdChargePayment?.search}?offset=${pageNumber}&pageSize=${pageSize}`, reqObj, 'post')
            if (res?.code === 200) {

                let resData = res?.data?.sdChargeSequencingMasterDtoList?.map(item => (
                    {
                        ...item, tribyteAccess: item?.tribyteAndWebsiteIntegrationList.map(l => (
                            { label: l?.tribyteAccess, value: l?.tribyteAccess }
                        )), websiteIntegration: item?.tribyteAndWebsiteIntegrationList[0] && item?.tribyteAndWebsiteIntegrationList[0]?.websiteIntegration
                    }
                ))

                if (!isBranchLevelConfig && resData.length) {
                    const defaultMatch = resData.find(
                        item =>
                            item.status === 'ACTIVE' &&
                            item.academicCareer === 'RCC' &&
                            item.companyCode === 'AESL1' &&
                            item.businessGroup === 'AEGP'
                    );
                    if (defaultMatch) {
                        const { businessArea, id, createdOn, createdBy, updatedOn, updatedBy, ...rest } = defaultMatch;

                        setDefaultRow({
                            ...rest,
                            businessArea: "",
                        });
                    }
                }
                setCurrentPageSize(pageSize);
                setRows(resData);
                setPaginationInfo({
                    currentPage: res?.data?.currentPage,
                    totalPage: res?.data?.totalPage,
                    totalRecords: res?.data?.totalRecords,
                });
                listRef.current.stopEditing();
            }
            else {
                setRows([])
            }
        }
        catch (error) {
            console.log(error)
        }
        finally {
            setLoader(false)
        }
    }

    const createHandler = async rowData => {
        setLoader(true);
        const reqBody = getCreateReqBody(rowData);
        try {
            const res = await fetchAllPostPromisedData(
                endpoint?.sdChargePayment?.create,
                reqBody,
                'post'
            );
            if (res?.code === 200) {
                successToast(res?.message);
                fetchList({}, 0, currPageSize, false);
                setFilterForm({ ...EMPTY_FILTER_FORM });
            }
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setLoader(false)
        }
    }

    const deleteHandler = async (id) => {
        try {
            const resp = await deleteConfig(id);
            if (resp) {
                successToast("Request completed successfully!");
                fetchList({}, paginationInfo?.currentPage, currPageSize, false);
            }
        } catch (e) {
            console.error(e);
        } finally {

        }
    }

    const filterFormHandler = (key, value) => {
        setFilterForm((prev) => ({ ...prev, [key]: value ?? [] }));
    };

    const updateHandler = async (rowData) => {
        setLoader(true);
        const { itemType } = rowData;
        const reqBody = getCreateReqBody(rowData)
        try {
            const res = await fetchAllPostPromisedData(
                `${endpoint.sdChargePayment.update}/${rowData?.id}`,
                reqBody,
                'put'
            );
            if (res?.code === 200) {
                successToast(res?.message);
                fetchList({}, paginationInfo?.currentPage, currPageSize, false);
                setFilterForm({ ...EMPTY_FILTER_FORM });

            }
            else {
                failureToast(res?.message);
            }
        }
        catch (error) {
            console.log(error)
        }
        finally {
            setLoader(false)
        }


    }

    useEffect(() => {
        Object.keys(dropdownData)?.length > 0 && fetchList()
    }, [dropdownData])

    const nextButtonHandler = (newPage, currPageSize) => {
        const { businessAreas, academicCareers, status } = filterForm;

        const reqObj = {
            businessAreas: Array.isArray(businessAreas) ? businessAreas.map(item => item.label) : [],
            academicCareers: Array.isArray(academicCareers) ? academicCareers.map(item => item.label) : [],
            status,
        };
        fetchList(reqObj, newPage, currPageSize, false);
    };
    const toggleStatusHandler = async rowData => {
        setLoader(true);
        const reqBody = {
            ...getCreateReqBody(rowData),
            status: rowData?.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
        };
        const res = await fetchAllPostPromisedData(
            `${endpoint.sdChargePayment.update}/${rowData?.id}`,
            reqBody,
            'put'
        );
        if (res?.code === 200) {
            successToast(res?.message);
            fetchList({}, paginationInfo?.currentPage);
        } else {
            failureToast(res?.message);
        }
        setLoader(false);
    };

    const applyFilterHandler = (reqObj = {}) => {
        const { academicCareers, businessAreas, status } = reqObj;

        let finalBusinessAreas = [];
        if (businessAreas && businessAreas.length > 0) {
            finalBusinessAreas = getDropdownLabelsFromSelectArray(businessAreas);
        } else if (isBranchLevelConfig) {
            finalBusinessAreas = dropdownData?.activeBusinessAreas?.map(bu => bu?.label) || [];
        } else {
            // PAN India config default
            finalBusinessAreas = ['ALL'];
        }

        const filterObj = {
            businessAreas: finalBusinessAreas,
            academicCareers: getDropdownLabelsFromSelectArray(academicCareers),
            status: status ?? ""
        };

        setFilterForm((prev) => ({
            ...prev,
            appliedFilterCount: getAppliedFilterCount(reqObj, ['appliedFilterCount', 'status'])
        }));

        fetchList(filterObj, 0, currPageSize, true);
    }


    return (
        <div className={`remove-container-top-space`}>
            {(dropdownDataLoading || loader) && (
                <ALoader position="fixed" />
            )}
            <div className={`${styles['page-container']}`}>
                <div className="d-flex justify-content-between align-items-start">
                    <div className={`${styles['header-bar']}`}>
                        {/* <BackIcon onClick={() => history.goBack()} /> */}
                        <div className="ml-3 heading-4 color-dark">
                            {isBranchLevelConfig
                                ? 'BU Level Configuration'
                                : 'PAN India Configuration'
                            }
                        </div>
                    </div>

                    <div className={styles['right-actions']}>
                        {isBranchLevelConfig &&
                            <Filters
                                setFilterForm={setFilterForm}
                                dropdownData={dropdownData}
                                filterForm={filterForm}
                                applyFilterHandler={applyFilterHandler}
                                handleFilterForm={filterFormHandler}
                            />
                        }
                        {checkPermission(userPermissions, 'C') && <AButton
                            // updatedStyle={{ fontWeight: 600 }}
                            onClick={() => listRef?.current?.addNewRow()}
                            variant="primary_filled"
                        >
                            Add configuration
                        </AButton>
                        }
                    </div>

                </div>
                <ListComponent
                    ref={listRef}
                    rows={rows}
                    currentPage={paginationInfo?.currentPage}
                    currPageSize={currPageSize}
                    rowCount={paginationInfo?.totalRecords}
                    loader={loader}
                    dropdown={dropdownData}
                    createHandler={createHandler}
                    updateHandler={updateHandler}
                    toggleStatusHandler={toggleStatusHandler}
                    deleteHandler={deleteHandler}
                    nextButtonHandler={nextButtonHandler}
                    isNew={isNew}
                    setIsNew={setIsNew}
                    isBranchLevelConfig={isBranchLevelConfig}
                    defaultRow={defaultRow}
                />
            </div>
        </div>

    )

}
export default SecurityDepositSequencing;